import type { RouteRecordRaw } from 'vue-router'
import { InventoryPage } from '@myorg/inventory-lib'
import { api } from '../../services/api'
import {ROUTES, API_ENDPOINTS} from '@myorg/type-lib'

const inventoryApi = {
  getInventory: () => api().get(`${API_ENDPOINTS.BLOG.GET_POSTS}?page=0&size=5`).then(r => r.data)
}

export const inventoryRoute: RouteRecordRaw = {
  path: ROUTES.INVENTORY.PATH,
  name: ROUTES.INVENTORY.NAME,
  component: InventoryPage,
  props: { api: inventoryApi }
}
